var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonsbackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1393.24 1556.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: rgba(0, 0, 0, .1);\n        stroke-width: 3.7px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.25,759.96l-.11.02c-116.83-274,10.63-590.44,284.57-707.03h0c197.83-84.46,418.21-41.45,569.34,91.94-178.65,10-308.43,53.15-400.99,117.02-93.36,64.41-148.73,149.82-178.22,243.21-58.45,185.14-15.18,401.7,35.2,548.99-134.58-49.43-249.22-151.89-309.79-294.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.04,340.89c-37.83,420.11,159.15,689.87,418.68,815.55,259.07,125.45,580.48,107.33,792.44-48.03-60.73,153.79-188.62,281.66-349.43,358.97-405.64,194.77-809.34-50.1-938.8-369.62C-35.07,867.78,3.66,579.71,135.04,340.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1363.15,599.3h0c23.87,117.94,3.47,217.45-46.05,304.36-48.93,85.85-126.32,159.5-217.76,226.44,39.87-267.9,25.79-433.13-31.05-542.29-56.81-109.11-156.11-161.83-285.61-205.23,152.61-162.86,515.39-106.05,580.47,216.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonsbackground);
export default __webpack_public_path__ + "static/media/moonsbackground.2ff560c75498d1e9ca6f440d7e0deb3b.svg";
export { ForwardRef as ReactComponent };